import React from 'react'
import { oreillyPlaylistSE } from '../DataAndAPIs/Links'

import { softwareEngineeringSprint7Link } from '../Activities/ClassProduct'
import { finalProjectSprint7Link } from '../Activities/FinalProject'
import { externalLink } from '../DataAndAPIs/Links'
import { getModuleDescription } from '../DataAndAPIs/ClassSections'

import { sprintEndDateWithoutTime } from '../CalendarAndSchedule/SprintDates'
import { scheduleLinkV2 } from '../DataAndAPIs/Links'
import { estimated } from './AL00000Sprint00'

import { getClassSectionID } from '../DataAndAPIs/ClassSections'
import { getFinalExamDateAndTime } from '../DataAndAPIs/ClassSections'
import { classProductPresentationLink } from '../Activities/ClassProduct'

export const al44000Sprint07 = () => {
	const sprint = 7
	return ( <div>
		<h5>Sprint 7: {getModuleDescription(sprint-1)}</h5>
		<p>It is time to deliver core essential functionality to our product. You have three weeks and an estimated 
		20 story points (hours) capacity to deliver something that will make you proud. And possibly make customers 
		adore you? What will you work on? What will you deliver? What will you own?</p>
		
		<p>After this sprint the product is yours. Make sure your team owns (has admin rights) to everything associated 
		with the product.</p>

		<p>Our Learning Objectives for this sprint include:</p>
		<ul style={{listStyleType:'square'}}>
			<li>Utilize your knowledge of Agile development and SaaS to deliver a class product that you are proud of creating</li>
			<li>Understand Design Patterns with a particular focus on the Model-View-Controller pattern</li>
		</ul>

		{list44000Sprint07(sprint)}
	</div> )
}

export const list44000Sprint07 = (sprint) => {
	const agileCoachInterview = () => { return externalLink('Interview with an Agile Coach', 'https://www.youtube.com/watch?v=bB340S0tGf8')}
	return ( <div>
		<p>Below is our activities list which, according to our {scheduleLinkV2(getClassSectionID(), sprint)}, needs to be 
		completed by {sprintEndDateWithoutTime(sprint-1)}:</p>
		<ol>
			<li>Review assignments including Discussion, Final Exam, Lab, Reflection, and Lab Demo</li>
			<li>Verify that you will attend class in person and complete your <em>Final Exam on Tuesday, May 5</em></li>
			<li>Verify that you will attend in person and deliver your <em>{classProductPresentationLink()} on {getFinalExamDateAndTime()}</em></li>
			<li>Complete Sprint {sprint} Planning and submit “Lab {sprint} Planning” which includes {softwareEngineeringSprint7Link()} Requirements 0, 1, and 2</li>
			<li>Read Chapter 10 of Fox on Project Management, Scrum, Pairs, and Version Control Systems</li>
			<li>Review {agileCoachInterview()}</li>
			<li>Submit your initial Discussion post by the middle of the sprint</li>
			<li>Within {oreillyPlaylistSE()} read “Design Patterns” through chapter 1</li>
			<li>Complete {finalProjectSprint7Link()} {estimated('12 hours per team member')}</li>
			<li>Submit Discussion, Final Exam, Lab, and Reflection</li>
		</ol>
	</div> )
}

// Certified for SP25 on April 6, 2025




